export enum VIRTUAL_MODULE_REFERENCE_SECTION {
  WORKFLOWS = 'Workflows',
}

export enum VIRTUAL_MODULE_REFERENCE_CATEGORY {
  SECURITY_OPTION = 'Security Option',
  SOURCE = 'Source',
}

export enum VIRTUAL_MODULE_SECURITY_OPTION_REFERENCE_CATEGORY_FIELD {
  TYPE = 'Type',
}

export enum VIRTUAL_MODULE_SOURCE_REFERENCE_CATEGORY_FIELD {
  TYPE = 'Type',
}

export enum BUTTON_TYPES {
  ICON_TEXT_BUTTON = 'ICON_TEXT_BUTTON',
  ICON_BUTTON = 'ICON_BUTTON',
  TOGGLE_BUTTON = 'TOGGLE_BUTTON',
}

export enum WORKFLOW_STATUS {
  ACTIVE = 'Submitted',
  DRAFT = 'Drafted',
  DELETED = 'Pending Submission',
  DEACTIVATE = 'DEACTIVATE',
}
export enum STAGE_ACTION {
  SUBMIT = 'SUBMIT',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  CANCEL = 'CANCEL',
  RETURN = 'RETURN',
  ESCALATE = 'ESCALATE',
  HOLD = 'HOLD',
  RESUME = 'RESUME',
  COMPLETE = 'COMPLETE',
}

export enum TRUE_ACTIONS {
  ACTIVATE = 'ACTIVATE:DEACTIVATE',
  ENABLE = 'ENABLE:DISABLE',
}

export enum STAGE_ROUTING_STATUS {
  NO_STATUS_CHANGE = 'NO_STATUS_CHANGE',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  RETURNED = 'RETURNED',
  ESCALATED = 'ESCALATED',
}

export enum STAGE_STATUS_ACTION_TYPES {
  LINK_SEND = 'Link Send',
  DELETE = 'Delete',
}
export enum TOGGLE_OPTIONS {
  ACTIVE = 'ACTIVATE : DEACTIVE',
  ENABLE = 'ENABLE :DISABLE',
}

export enum STAGE_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

export enum PAYOUTS_PERMISSION_ACTIONS {
  READ_BATCHES = 'READ:BATCHES',
  WRITE_BATCHES = 'WRITE:BATCHES',
  EDIT_BATCHES = 'EDIT:BATCHES',
  DELETE_BATCHES = 'DELETE:BATCHES',

  READ_DEDUCTIONS = 'READ:DEDUCTIONS',
  WRITE_DEDUCTIONS = 'WRITE:DEDUCTIONS',
  EDIT_DEDUCTIONS = 'EDIT:DEDUCTIONS',
  DELETE_DEDUCTIONS = 'DELETE:DEDUCTIONS',

  READ_EARNINGS = 'READ:EARNINGS',
  WRITE_EARNINGS = 'WRITE:EARNINGS',
  EDIT_EARNINGS = 'EDIT:EARNINGS',
  DELETE_EARNINGS = 'DELETE:EARNINGS',

  READ_COMMISSION_BREAKDOWN = 'READ:COMMISSION_BREAKDOWN',
  WRITE_COMMISSION_BREAKDOWN = 'WRITE:COMMISSION_BREAKDOWN',
  EDIT_COMMISSION_BREAKDOWN = 'EDIT:COMMISSION_BREAKDOWN',
  DELETE_COMMISSION_BREAKDOWN = 'DELETE:COMMISSION_BREAKDOWN',

  READ_ENTRIES = 'READ:DATA_ENTRIES',
  WRITE_ENTRIES = 'WRITE:ENTRIES',
  EDIT_ENTRIES = 'EDIT:ENTRIES',
  DELETE_ENTRIES = 'DELETE:ENTRIES',

  READ_BANK_ORDER = 'READ:BANK_ORDER',
  WRITE_BANK_ORDER = 'WRITE:BANK_ORDER',

  VIEW_BREAKDOWN = 'VIEW_BREAKDOWN',
  APPROVE = 'APPROVE',
  REJECT_CANCELLATION = 'REJECT_CANCELLATION',
  APPROVE_CANCELLATION = 'APPROVE_CANCELLATION',
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  APPROVE_REPROCESSING = 'APPROVE_REPROCESSING',
  GENERATE_BANK_ORDER = 'GENERATE_BANK_ORDER',
  PRINT_PAYSLIP = 'PRINT_PAYSLIP',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
  PROCESS_PAYMENT = 'PROCESS_PAYMENT',
}
